// feedbackApi — small client for the feedback inbox (ticket 126). Same `api`
// axios instance FeedbackList.jsx calls directly; params are handed to
// axios's own query-string serializer, which drops undefined/null values, so
// callers can pass a full params object and let "no filter" mean omitted.
import { api } from '../api';

export const feedbackApi = {
  list: (params = {}) => api.get('/feedback', { params }),
  bulkSetStatus: (ids, status) => api.post('/feedback/bulk-status', { ids, status }),
};
